import { methodGet } from './methods';
import { API_INFO } from '../constants';

export const getFilters = async() => {
  return methodGet(API_INFO + 'payment/commission-summary/filters');
}

